import React from 'react';

const Hero = ({ onBookClick }) => {
  return (
    <section className="relative min-h-screen flex items-center pt-16">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://customer-assets.emergentagent.com/job_plant-sanctuary-2/artifacts/7s5bbozz_FB_IMG_1744596937359.jpg"
          alt="AGreenerSide greenhouse with sustainable growing practices"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 to-black/30"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
        <div className="max-w-3xl">
          <h1 
            className="text-5xl sm:text-6xl lg:text-7xl font-bold text-white mb-4 leading-tight"
            style={{ fontFamily: "'Crimson Text', serif" }}
          >
            A Greener Side Nursery
          </h1>
          <p className="text-2xl sm:text-3xl text-white font-semibold mb-6">
            Open 9:00 AM – 6:00 PM Daily · Closed Sunday
          </p>
          <p className="text-lg sm:text-xl text-gray-100 mb-8 leading-relaxed italic border-l-4 border-white/50 pl-4">
            Experience Permaculture at A Greener Side — where sustainability meets education.
          </p>
        </div>
      </div>

    </section>
  );
};

export default Hero;
